import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import HeroSection from './HeroSection';
import * as Typography from './Typography';
import GetInTouchSection from './GetInTouchSection';


import firebase from './firebase';
import {getQueryVariable} from './history';

const ConfirmDeliveryPage = muiThemeable()(class extends Component {
  state = {
    window: null,
  }

  componentDidMount() {
    var window_id = getQueryVariable("window");

    firebase.database().ref().child("delivery").child("windows").child(window_id).on('value',
      (snapshot) => {
        this.setState({window: snapshot.val()});
    });
  }

  render() {
    return this.state.window &&
       <div>
         <HomeGalleryHeader />

         <div style={{
             margin: 'auto',
             textAlign: 'center',
             fontWeight: 'normal',
             backgroundColor: this.props.muiTheme.palette.canvasColor,
             fontFamily: "'Roboto', sans-serif",
           }}>

           <HeroSection
             header="Thank you!" />

           <div style={{
               marginTop: "40px",
               marginLeft: 'auto',
               marginRight: 'auto',
               maxWidth: '400px',
               width: '90%',
             }}>
             <Typography.Headline>You're all set</Typography.Headline>
             <Typography.Subheading>Delivery confirmed for {this.state.window.display_date} from {this.state.window.display_title}. We'll give you a call when we're nearby.</Typography.Subheading>
           </div>

           <GetInTouchSection />

          </div>
         <HomeGalleryFooter />
       </div>
  }
});

export default ConfirmDeliveryPage;



// WEBPACK FOOTER //
// ./src/ConfirmDeliveryPage.js